import { motion } from "framer-motion";
import { FileText, ClipboardList, Handshake, Truck, LifeBuoy } from "lucide-react";

const STEPS = [
  {
    icon: FileText,
    title: "Запрос",
    desc: "Вы отправляете заявку, спецификацию или ТЗ. Помогаем сформулировать при необходимости.",
  },
  {
    icon: ClipboardList,
    title: "Подбор",
    desc: "Подбираем позиции, предлагаем аналоги и оптимальную комплектацию по цене и срокам.",
  },
  {
    icon: Handshake,
    title: "Договор",
    desc: "Согласуем условия, оформляем коммерческое предложение и договор поставки.",
  },
  {
    icon: Truck,
    title: "Поставка",
    desc: "Организуем отгрузку и доставку. Сопровождаем груз до получателя.",
  },
  {
    icon: LifeBuoy,
    title: "Поддержка",
    desc: "Контролируем документы, гарантию и остаёмся на связи для повторных заказов.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="section relative bg-[#0A192F] text-white overflow-hidden"
    >
      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      <div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] opacity-20"
        style={{
          background:
            "radial-gradient(circle, rgba(255,107,0,0.6) 0%, transparent 70%)",
        }}
      />

      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-6 !text-[#FF6B00]">Как мы работаем</div>
            <h2 className="font-display text-white text-3xl sm:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
              Прозрачный процесс от&nbsp;заявки до&nbsp;поддержки
            </h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 text-white/70 text-base lg:text-lg">
            Стандартизированные этапы помогают нам вовремя поставлять нужную продукцию,
            а вам — заранее понимать, что происходит с вашим заказом.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-8 left-8 right-8 h-px bg-white/15" />

          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`process-step-${i}`}
                className="relative"
              >
                <div className="relative z-10 w-16 h-16 bg-[#0A192F] border border-white/20 flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-[#FF6B00]" />
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2 tabular-nums">
                  Этап 0{i + 1}
                </div>
                <div className="font-display text-white text-xl font-semibold mb-3">
                  {s.title}
                </div>
                <div className="text-sm text-white/70 leading-relaxed">
                  {s.desc}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
